<template>
  <v-app>
    <platform-supported>
      <app-main></app-main>
    </platform-supported>
  </v-app>
</template>

<script>
  import PlatformSupported from './components/framework/gates/PlatformSupported';
  import AppMain from "./components/AppMain";
  export default {
    name: 'App',
    components: {
      AppMain,
      PlatformSupported,
    },
    data: () => ({

    }),
    mounted(){

    },
    methods : {

    }
  };
</script>
